module.exports = __webpack_public_path__ + "static/media/checkmark-upload-success.08ba15b3.svg";